import { DecisionEnvironment } from "src/api/types";
import { getUrlToHistoricDecisionTrace } from "src/router/urls";

// Returns undefined for an unknown env so we never default sandbox to live.
const toDecisionEnvironment = (
  env?: string,
): DecisionEnvironment | undefined => {
  if (env === DecisionEnvironment.SANDBOX) return DecisionEnvironment.SANDBOX;
  if (env === DecisionEnvironment.LIVE) return DecisionEnvironment.LIVE;
  return undefined;
};

type BuildDecisionTraceUrlParams = {
  orgId: string;
  wsId: string;
  flowId?: string | null;
  versionId?: string | null;
  decisionId?: string | null;
  env?: string;
};

// Builds the decision trace link from known IDs; undefined if any is missing
// (including env, so we never link to the wrong environment).
export const buildDecisionTraceUrl = ({
  orgId,
  wsId,
  flowId,
  versionId,
  decisionId,
  env,
}: BuildDecisionTraceUrlParams): string | undefined => {
  const decisionEnv = toDecisionEnvironment(env);

  if (!flowId || !versionId || !decisionId || !decisionEnv) {
    return undefined;
  }

  return getUrlToHistoricDecisionTrace({
    orgId,
    wsId,
    flowId,
    versionId,
    decisionId,
    decisionEnv,
  });
};
